/**
 * Handles decimal inches to millimeters conversion calculations
 */
export class DecimalMillimeterConverter {
  /**
   * Conversion factor: 1 inch = 25.4 millimeters
   */
  static INCHES_TO_MM = 25.4

  /**
   * Convert decimal inches to millimeters
   * @param {number} inches - Value in decimal inches
   * @returns {number} Value in millimeters, rounded to 2 decimal places
   */
  inchesToMillimeters(inches) {
    if (isNaN(inches)) return ''
    return this.round(inches * DecimalMillimeterConverter.INCHES_TO_MM)
  }

  /**
   * Convert millimeters to decimal inches
   * @param {number} millimeters - Value in millimeters
   * @returns {number} Value in decimal inches, rounded to 2 decimal places
   */
  millimetersToInches(millimeters) {
    if (isNaN(millimeters)) return ''
    return this.round(millimeters / DecimalMillimeterConverter.INCHES_TO_MM)
  }

  /**
   * Round a number to 2 decimal places
   * @private
   */
  round(value) {
    return Math.round((value + 0.00001) * 100) / 100
  }
}
